<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/dvv/criteria3/3-4-3-1"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>3.4.3.1 Extension Activities Reports</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active" class="sub-menu">
                        <a  routerLink="/naac/dvv/criteria3/3-4-3-1/Activities-Reports/2021-22" (click)="checkRoute()">2021-22</a>
                    </li>
                    <li routerLinkActive="active" class="sub-menu">
                        <a  routerLink="/naac/dvv/criteria3/3-4-3-1/Activities-Reports/2020-21" (click)="checkRoute()">2020-21</a>
                    </li>
                    <li routerLinkActive="active" class="sub-menu">
                        <a  routerLink="/naac/dvv/criteria3/3-4-3-1/Activities-Reports/2019-20" (click)="checkRoute()">2019-20</a>
                    </li>
                    <li routerLinkActive="active" class="sub-menu">
                        <a  routerLink="/naac/dvv/criteria3/3-4-3-1/Activities-Reports/2018-19" (click)="checkRoute()">2018-19</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <h4 class="text-center">Extension Activities Reports</h4>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>